import styled, { css } from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  flex-wrap: wrap;
  height: 65px;
  padding: 0 20px;
  width: 100vw;
  align-items: center;
  background-color: #202020;

  button {
    padding: 15px 25px;
    border-width: 0px;
    border-radius: 50px;
    background-color: #343434;
    color: #fff;
    align-items: center;
    justify-content: center;
  }

  p {
    color: #fff;
    font-size: 16px;
    font-weight: 500;
  }

  .title {
    display: flex;
    flex-direction: row;
    flex: 1;
  }
`;
